import { FormEvent } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { ICriminalRCstore } from "..";
import { IConsultaCriminal } from "../../../interface/criminal";

export interface ICriminalRCModuleStore {
  resultadoCriminalRC: IConsultaCriminal[] | null;
  mensagemCriminal?: string;
  consultaCriminalRC(url: string, rc: string, e?: FormEvent): Promise<void>;
  limparConsultaCriminalRC(): void;
}

export default (set: SetState<ICriminalRCstore>) =>
  ({
    resultadoCriminalRC: null,
    async consultaCriminalRC(url, rc, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        const response = await axios.get(
          `${url}/wsCriminal/BuscarCidadaoPorRC/${rc}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response.status === 200) {
          set((state) => ({
            ...state,
            global: {
              ...state.global,
              loading: false,
            },
            criminal: {
              ...state.criminal,
              resultadoCriminalRC: response.data,
            },
          }));
        }
        if (response.status === 400) {
          toast.error(`${response.data}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
        if (response.status === 401) {
          toast.error(
            "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          // logout()
        }
        if (response.status === 404) {
          set((state) => ({
            criminal: {
              ...state.criminal,
              resultado: null,
              mensagemCriminal: response.data,
            },
          }));
        }
        if (response.status === 500 || response.status === 503) {
          toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
          return;
        }
        if (response.status === 504 || response.data === 504) {
          toast.error(
            "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          return;
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaCriminalRC() {
      set((state) => ({
        ...state,
        criminal: {
          ...state.criminal,
          resultado: null,
          mensagemCriminal: undefined,
        },
      }));
    },
  } as ICriminalRCModuleStore);
